/**
 * Волна E (docs/MIGRATION_ROUTER.md §5).
 * Было: <CacheDataRoute exact path='/bar-menu/:barId/:tableId' withoutFooter withoutHeader>.
 * path в staticData — для consent-модалки Header (includes('/bar-menu/')).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../../CacheDataRoute';
import BarMenu from '@routes/BarMenu';

export const Route = createFileRoute('/bar-menu/$barId/$tableId/')({
  staticData: {
    layout: {
      path: '/bar-menu/:barId/:tableId',
      withoutHeader: true,
      withoutFooter: true
    }
  },
  component: () => (
    <CacheDataRoute component={BarMenu} path='/bar-menu/:barId/:tableId' />
  )
});
